import m from 'mithril'

export default m.trust(`
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 8L8 2H14V8L8 14H2V8Z" stroke="white" stroke-opacity="0.6" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="1 2"/>
<path d="M2 7.99997L8 2L14 2V7.99997L8.13387 14H2L2 7.99997Z" fill="white" fill-opacity="0.2"/>
</svg>
`)
